<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g stroke="#7F92A9" stroke-width="2">
      <circle cx="13" cy="3" r="2" />
      <circle cx="21" cy="9" r="2" />
      <circle cx="12" cy="13" r="4" />
      <circle cx="19" cy="21" r="2" />
      <circle cx="4" cy="20" r="2" />
      <circle cx="3" cy="9" r="2" />
      <line x1="13.123" x2="12.872" y1="5.0667" y2="9.0588" />
      <line x1="20.029" x2="16.443" y1="9.8965" y2="11.669" />
      <line x1="17.496" x2="14.374" y1="19.281" y2="16.78" />
      <line x1="6.044" x2="8.4298" y1="18.328" y2="15.498" />
      <line x1="4.3388" x2="7.8833" y1="9.8373" y2="10.903" />
    </g>
  </svg>
</template>

<script>
  export default {};
</script>

<style scoped></style>
